export const globalFaqs = [
  {
    id: 6,
    question: "What is your pricing model?",
    answer: "Our pricing is flexible and depends on the scope of services, volume, and specific requirements. We offer competitive rates and can provide both fixed-price and hourly billing options based on your needs."
  },
  {
    id: 8,
    question: "How can I partner with Xentovra?",
    answer: "Simply reach out to us via our Contact Page, email us at support@xentovra.in, or call our team. We'll schedule a consultation to assess your needs and design the right solution."
  },
  {
    id: 9,
    question: "What is the pricing model?",
    answer: "Our pricing is flexible and based on project requirements, number of resources, and service complexity. We offer cost-effective models suitable for startups, SMEs, and large enterprises."
  },
  {
    id: 10,
    question: "Can your services scale as my business grows?",
    answer: "Yes. Scalability is one of our biggest strengths. We can ramp up or scale down operations quickly to match your business needs."
  },
  {
    id: 15,
    question: "Do you support international clients?",
    answer: "Yes, we work with clients from across the globe, helping them manage business operations efficiently."
  },
  {
    id: 16,
    question: "Do you provide a trial or pilot project before full engagement?",
    answer: "Yes, we can conduct a pilot project so clients can evaluate our performance before entering into long-term partnerships."
  },
  {
    id: 17,
    question: "How can I contact Xentovra?",
    answer: "You can reach us via email at <a class='email-link' href='mailto:support@xentovra.in'>support@xentovra.in</a>"
  }
]
